// Cookie consent + gated analytics loaders. Analytics only load after the user accepts.
const KEY = "sc_cookie_consent"; // "accepted" | "declined"
const CLARITY_ID = "xbgt859npn";
const GA_ID = "G-S4Z1071YXV";

export function getConsent() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function setConsent(value) {
  try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
}

// Microsoft Clarity loader (the official snippet), guarded so it runs once.
export function loadClarity() {
  if (window.__clarityLoaded) return;
  window.__clarityLoaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
}

// Google Analytics 4 (gtag.js), guarded so it runs once. The config call fires one
// page_view for the landing page; SPA route changes are tracked via gaPageview().
export function loadGA4() {
  if (window.__ga4Loaded) return;
  window.__ga4Loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export function loadAnalytics() {
  loadClarity();
  loadGA4();
}

// Manual SPA page_view (the router has no full page reload). No-op until GA4 is loaded.
export function gaPageview(path) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// Fire a conversion / custom event. No-op until consent + GA4 are loaded.
export function trackEvent(name, params) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params || {});
}

// Call on app start: if the user already accepted, load analytics immediately.
export function initAnalytics() {
  if (getConsent() === "accepted") loadAnalytics();
}
